import React from 'react'
import styled from 'styled-components'
import DeleteConfirmation from './DeleteConfirmation'

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's on top */
`

const ModalContent = styled.div`
  background-color: white;
  border-top: 4px solid ${(props) => props.accentColor || '#c53030'};
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 90%;
  max-width: 500px;
`

const ConfirmationModal = ({ 
  questionText, 
  showConfirmation, 
  setShowConfirmation, 
  onConfirm,
  confirmationWord,
  accentColor
}) => {
  if (!showConfirmation) {
    return null
  }

  return (
    <ModalOverlay>
      <ModalContent accentColor={accentColor}>
        <DeleteConfirmation
          questionText={questionText}
          showDeleteConfirmation={showConfirmation}
          setShowDeleteConfirmation={setShowConfirmation}
          onConfirm={onConfirm}
          confirmationWord={confirmationWord}
        />
      </ModalContent>
    </ModalOverlay>
  )
}

export default ConfirmationModal
